import React from "react"
import styled from "styled-components"
import Fade from "react-reveal/Fade"
import airport1 from "../images/airport-1.jpg"
import airport2 from "../images/airport-2.jpg"
import airport3 from "../images/airport-3.jpg"
import airport4 from "../images/airport-4.jpg"

const AirportSectionWrapper = styled.section`
  background-color: var(--secondary-color);
  padding: 70px 0 80px 0;
  color: var(--six-color);

  @media only screen and (max-width: 767px) {
    padding: 50px 0 60px 0;
  }
`

const SectionHeader = styled.div`
  margin-bottom: 36px;
`

const SectionTitle = styled.h2`
  margin: 0 0 8px 0;
  font-family: var(--font-bold);
  font-size: 2.4em;
  color: var(--primary-color);

  @media only screen and (max-width: 767px) {
    font-size: 2em;
  }
`

const SectionSubtitle = styled.p`
  margin: 0;
  font-family: var(--font-md);
  font-size: 1em;
  line-height: 1.7em;
  max-width: 520px;
`

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-gap: 24px;

  @media only screen and (max-width: 991px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media only screen and (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`

const Card = styled.article`
  text-align: center;
  font-family: var(--font-md);
`

const ImagePlaceholder = styled.div`
  width: 100%;
  padding-top: 70%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.25);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 12px;
  overflow: hidden;
`

const CardTitle = styled.h3`
  margin: 0;
  font-family: var(--font-bold);
  font-size: 0.95em;
  line-height: 1.6em;
`

const AirportExperienceSection = () => {
  const items = [
    {
      title: "Supervisión y dictamen en concesiones",
      image: airport1,
    },
    {
      title: "Evaluación costo-beneficio",
      image: airport2,
    },
    {
      title: "Programas Maestros de Desarrollo en aeropuertos estatales",
      image: airport3,
    },
    {
      title: "Estudios de rentabilidad en proyectos de mantenimiento",
      image: airport4,
    },
  ]

  return (
    <AirportSectionWrapper>
      <div className="container">
        <Fade up>
          <SectionHeader>
            <SectionTitle>Experiencia aeroportuaria</SectionTitle>
            <SectionSubtitle>
              Proyectos especializados en el sector aeroportuario que abarcan
              desde la supervisión y el dictamen en concesiones hasta el
              análisis de rentabilidad y la planeación de programas maestros de
              desarrollo.
            </SectionSubtitle>
          </SectionHeader>
          <CardsGrid>
            {items.map(item => (
              <Card key={item.title}>
                <ImagePlaceholder
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <CardTitle>{item.title}</CardTitle>
              </Card>
            ))}
          </CardsGrid>
        </Fade>
      </div>
    </AirportSectionWrapper>
  )
}

export default AirportExperienceSection
